import React from 'react';
import styled, { css } from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectDealer } from '@/store/reducers/single-dealer';
import PostCardSlider from '@/components/PostCardSlider';
import { ContentContainerSmall } from '@/components/ContentContainer';
import { media } from '@/utils/mixin';

function Offers() {
  const dealer = useTypedSelector(selectDealer);

  if (!dealer || !dealer.offers || dealer.offers.length === 0) {
    return null;
  }

  return (
    <Component>
      <ContentContainerSmall>
        <Title>Акции дилерского центра</Title>

        <PostCardSlider
          posts={dealer.offers.map(({ image, title, url }) => ({
            image,
            title: title ?? '',
            url: url ?? '',
          }))}
        />
      </ContentContainerSmall>
    </Component>
  );
}

export default Offers;

const Component = styled.section`
  padding: 20px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0 20px;
    `)}
  }
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 26px;
    line-height: 34px;
  `)}
`;
